import { ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import { getPanelColor, getPanelTitleColor } from '../theme/wallThemeStyles';
import { useWallStore } from '@walls/store';

interface AiActionMenuProps {
  anchorEl: HTMLElement | null;
  groupByGroupDisabled?: boolean;
  groupByThemeDisabled?: boolean;
  groupByThemeSubscriptionRequired?: boolean;
  onClose: () => void;
  onGroupByGroup: () => void;
  onGroupByTheme: () => void;
  onOrderCards: () => void;
}

export function AiActionMenu({
  anchorEl,
  groupByGroupDisabled = false,
  groupByThemeDisabled = false,
  groupByThemeSubscriptionRequired = false,
  onClose,
  onGroupByGroup,
  onGroupByTheme,
  onOrderCards,
}: AiActionMenuProps) {
  const theme = useWallStore((state) => state.theme);

  const panelColor = getPanelColor(theme);
  const panelTitleColor = getPanelTitleColor(theme);

  return (
    <Menu
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{
        paper: { sx: { bgcolor: panelColor, color: panelTitleColor, minWidth: 200, mt: 1 } },
      }}
    >
      <MenuItem onClick={onOrderCards}>
        <ListItemText primary="Order page cards" />
      </MenuItem>
      <MenuItem onClick={onGroupByGroup} disabled={groupByGroupDisabled}>
        <ListItemText primary="Group cards by Group" />
      </MenuItem>
      <Tooltip
        title={groupByThemeSubscriptionRequired ? 'Available with a gold subscription' : ''}
        placement="right"
      >
        <span>
          <MenuItem onClick={onGroupByTheme} disabled={groupByThemeDisabled}>
            <ListItemText primary="Group cards by theme" />
          </MenuItem>
        </span>
      </Tooltip>
    </Menu>
  );
}
